import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "mcevents_pwa_dismissed_until";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissedUntil = Number(localStorage.getItem(DISMISS_KEY) || 0);
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      if (Date.now() >= dismissedUntil) setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setVisible(false);
  };

  const dismiss = () => {
    setVisible(false);
    // Snooze for 7 days
    localStorage.setItem(DISMISS_KEY, String(Date.now() + 7 * 24 * 3600 * 1000));
  };

  if (!visible) return null;

  return (
    <div data-testid="install-prompt" className="md:hidden fixed left-3 right-3 z-50 card-mc bg-card border-foreground shadow-xl"
         style={{ bottom: "calc(72px + env(safe-area-inset-bottom))" }}>
      <div className="p-4 flex items-center gap-3">
        <div className="w-11 h-11 bg-[hsl(var(--primary))] text-white flex items-center justify-center font-display font-black text-lg rounded-sm shrink-0">mc</div>
        <div className="flex-1 min-w-0">
          <p className="font-display font-black text-sm leading-tight">Installer mcevents</p>
          <p className="text-[11px] text-muted-foreground leading-snug mt-0.5">Ajoutez l'application à votre écran d'accueil.</p>
        </div>
        <button data-testid="install-prompt-accept" onClick={install} className="bg-foreground text-background font-bold text-xs px-3 py-2 rounded-sm">
          <Download className="w-3.5 h-3.5 inline mr-1" /> Installer
        </button>
        <button data-testid="install-prompt-dismiss" onClick={dismiss} aria-label="Fermer" className="text-muted-foreground p-1">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
